export default __webpack_public_path__ + "static/media/lex.3e97e3d8.png";